import axios from '@/api/axios';
import type {
  AfriexLoginRequest,
  AfriexNonceResponse,
  AfriexOTPRequest,
  AfriexOTPResendRequest,
  AfriexPasswordRequest,
  AfriexPasswordUpdateRequest,
  AfriexTokenResponse,
} from '@/types';
import {AfriexMessageChannel} from '@/types';

export const authService = {
  sendLogin: async (body: AfriexLoginRequest): Promise<AfriexNonceResponse> => {
    const response = await axios.post<AfriexNonceResponse>(
      `/v2/admin/users/login`,
      body,
    );
    return response.data;
  },
  // Signs in from the Cloudflare Access identity (production only).
  sso: async (): Promise<AfriexTokenResponse> => {
    const response =
      await axios.post<AfriexTokenResponse>(`/v2/admin/users/sso`);
    return response.data;
  },
  sendOTP: async (
    code: string,
    nonce: string,
  ): Promise<AfriexTokenResponse> => {
    const body: AfriexOTPRequest = {
      nonce,
      code,
    };

    const response = await axios.post<AfriexTokenResponse>(
      `/v2/admin/users/otp`,
      body,
    );
    return response.data;
  },
  resendOTP: async (nonce: string): Promise<AfriexNonceResponse> => {
    const body: AfriexOTPResendRequest = {
      nonce,
      channels: [AfriexMessageChannel.Sms],
      deviceId: '',
    };
    const response = await axios.post<AfriexNonceResponse>(
      `/v2/admin/users/otp/resend`,
      body,
    );
    return response.data;
  },
  requestPasswordReset: async (
    body: AfriexPasswordRequest,
  ): Promise<AfriexNonceResponse> => {
    const response = await axios.post<AfriexNonceResponse>(
      `/v2/admin/users/password/reset`,
      body,
    );
    return response.data;
  },
  // Sent with the reset OTP's token, which is not the saved session yet.
  updatePassword: async (
    body: AfriexPasswordUpdateRequest,
    token: string,
  ): Promise<void> => {
    await axios.patch(`/v2/admin/users/password`, body, {
      headers: {Authorization: `Bearer ${token}`},
    });
  },
};
